module.exports = ".main-panel{\r\n  height: calc(100% - 255px);\r\n  overflow-y: auto;\r\n}\r\n.content-wrapper{\r\n    height: 100%;\r\n    overflow-y: auto;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/back/main/main.component.css
// module id = ./src/app/back/main/main.component.css
// module chunks = main